import { render } from "./callFollowUpFormV2.vue?vue&type=template&id=d4884598&scoped=true"
import script from "./callFollowUpFormV2.vue?vue&type=script&lang=js"
export * from "./callFollowUpFormV2.vue?vue&type=script&lang=js"

import "./callFollowUpFormV2.vue?vue&type=style&index=0&id=d4884598&scoped=true&lang=css"

import exportComponent from "/Users/habeebrahman/Documents/htdocs/cdz_projects/wg-frontend-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4884598"]])

export default __exports__